import React from 'react'

const About = () => {
  return (
    <div className='About 2xl:max-w-screen-2xl 2xl:mx-auto gap-5 py-16 p-6 justify-center flex flex-col text-center items-center lg:px-52'>
      <h1 className='font-bold text-xl font-josefin sm:text-2xl md:text-3xl lg:text-4xl text-black dark:text-white'>About DevNito</h1>
      <p className='text-xs text-black font-thin font-josefin sm:text-sm md:text-md lg:font-normal dark:text-gray-300 lg:text-lg'>DevNito is a leading provider of IT export services, offering custom software and SaaS solutions to businesses worldwide. With a focus on tailored excellence, transparent collaboration, and client-centricity, we aim to elevate your business to new heights.
      </p>
    </div>
  )
}

export default About